module.exports = __webpack_public_path__ + "img/search.8b5314a1.svg";